var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serverDetalii)?_c('div',{staticClass:"note-conflict-preview"},[_c('h4',[_vm._v("Notă server")]),_c('div',[_c('p',{staticClass:"new-note-preview"},[_vm._v(_vm._s(_vm.serverDetalii))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }